import { Component } from 'solid-js'
import { INITIAL_TOKEN_PLANS } from '/common/token-plans'

interface BonusTokensButtonProps {
  tokenCount?: number
  className?: string
  size?: 'small' | 'large'
}

const BonusTokensButton: Component<BonusTokensButtonProps> = (props) => {
  const tokenCount = props.tokenCount || INITIAL_TOKEN_PLANS[0].amount
  const className = props.className || ''
  const size = props.size || 'small'

  const isLarge = size === 'large'

  const buttonClasses = isLarge ? 'h-[242px] w-[239px]' : 'h-[121px] w-[123px]'

  const backgroundImage = isLarge
    ? '/images/free-bonus-tokens-wavy-circle-lg.png'
    : '/images/free-bonus-tokens-wavy-circle.png'

  const numberSize = isLarge ? 'text-[60px]' : 'text-[24px]'
  const textSize = isLarge ? 'text-[34px] leading-[40px]' : 'text-[18px]'
  const marginSize = isLarge ? 'mt-6' : 'mt-[6px]'

  return (
    <button
      class={`relative flex ${buttonClasses} items-center justify-center text-base font-semibold ${className}`}
    >
      <img
        src={backgroundImage}
        alt={`${tokenCount} Free Bonus Tokens`}
        class="absolute left-0 top-0 h-full w-full"
      />
      <span
        class={`relative font-semibold text-white [text-shadow:rgba(0,0,0,0.5)_0px_4px_4px] ${marginSize}`}
      >
        <span class={numberSize}>{tokenCount}</span>
        <span class={textSize}> Free Bonus Tokens!</span>
      </span>
    </button>
  )
}

export default BonusTokensButton
